import React, { useContext } from "react";
import { DataManagementContext } from "../context/data-context";

export const useAuth = () => {
    const data = useContext(DataManagementContext)
    return {
        ...data
    }
}